module.exports = __webpack_public_path__ + "img/location.5126a8e6.svg";